import { Module } from 'vuex'
import { RootState } from '../types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { NotificationsState } from './types'

export const notifications: Module<NotificationsState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions
}
